import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'wonderbly-components/lib/Icon';
import isEmpty from 'lodash/isEmpty';
import RichText from '../Prismic/RichText';
import Price from '../Price';
import EditableContent from './EditableContent';
import LineItemImage from './LineItemImage/LineItemImage';

const FixedContent = props => (
  <React.Fragment>
    {!isEmpty(props.expandedCustomisation) ? (
      <span className="line-item-customisation">
        <RichText fields={props.expandedCustomisation} />
      </span>
    ) :
      (
        <React.Fragment>
          <span className="line-item-customisation">{props.customisationString || ''}</span>
          <span className="line-item-option">
            {props.type}
            {!isEmpty(props.addons) && props.addons.map(addon => ` + ${addon.label}`)}
          </span>
        </React.Fragment>
      )}
  </React.Fragment>
);

FixedContent.propTypes = {
  expandedCustomisation: PropTypes.array,
  customisationString: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  addons: PropTypes.array.isRequired,
};

const LineItemContent = props => (
  <React.Fragment>
    <LineItemImage addons={props.addons} image={props.image} />
    <div className="line-item-ii-content" key="line-item-content">
      <div>
        <h3 className="line-item-ii-title">{props.title || ''}
          {props.customisationString && props.lineItemPrefix &&
            <span> {props.lineItemPrefix} </span>
          }
          {props.customisationString}
        </h3>
        {props.isEditable ? <EditableContent {...props} /> : <FixedContent {...props} />}
      </div>
      <Price className="line-item-ii-price" price={props.price} savings={props.savings} savingPriceString={props.savingsPriceLabel} savingsType="saved" />
    </div>
    {props.isRemovable && (
      <button
        key="line-item-delete"
        onClick={props.onRemove}
        className="line-item-ii-delete">
        <Icon icon="delete" />
      </button>
    )}
  </React.Fragment>
);

LineItemContent.propTypes = {
  isEditable: PropTypes.bool,
  isRemovable: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
  image: PropTypes.object,
  addons: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.object,
  savings: PropTypes.object,
  savingsPriceLabel: PropTypes.string,
  customisationString: PropTypes.string,
  lineItemPrefix: PropTypes.string,
};

export default LineItemContent;



// WEBPACK FOOTER //
// ./src/client/js/view/components/LineItemII/LineItemContentII.js